//Helpers
const elementIsInView = (selector, callback) => {
  const existing = document.querySelector(selector);
  if (existing) {
    callback(existing);
    return;
  }

  const observer = new MutationObserver((mutations) => {
    const target = document.querySelector(selector);
    if (target) {
      observer.disconnect();
      callback(target);
    }
  });

  observer.observe(document.body, {
    //Attributes
    childList: true,
    subtree: true,
  });
};

const getBreakerStep = (wrapper) => {
  const cols = getComputedStyle(wrapper).gridTemplateColumns;
  const columnCount =
    cols && cols !== "none" ? cols.split(" ").filter(Boolean).length : 1;
  return Math.max(columnCount, Math.round(8 / columnCount) * columnCount);
};

//Function to place and hide the breakers
const placeBreakers = () => {
  const wrapper = document.querySelector(".rb-items-wrapper");
  if (!wrapper) {
    return;
  }

  //Remove the old ones in the item list
  wrapper
    .querySelectorAll(".pm-0123-breaker-item")
    .forEach((item) => item.remove());

  //Get all Current Shown Items and all Breaker Elements
  const items = wrapper.querySelectorAll(".rb-item:not(.hidden)");
  const breaker = document.querySelectorAll(
    ".pm-0123-breaker .pm-0123-breaker-item"
  );
  if (!breaker.length) {
    return;
  }

  //For Each {step} Items clone the current Breaker and insert it
  const step = getBreakerStep(wrapper);
  let counter = 1;
  let breakerCounter = 0;
  items.forEach((item) => {
    if (counter === step) {
      item.insertAdjacentHTML("afterend", breaker[breakerCounter].outerHTML);
      counter = 0;
      breakerCounter++;

      //If More items then breaker reset
      if (breakerCounter >= breaker.length) breakerCounter = 0;
    }
    counter++;
  });
};

//Observer
const addObserver = () => {
  const root =
    document.querySelector("#bundling-app") ||
    document.querySelector("#build-a-box") ||
    document.body;

  let lastCount = -1;
  let scheduled = false;

  const check = () => {
    scheduled = false;

    const wrapper = document.querySelector(".rb-items-wrapper");
    if (!wrapper) {
      return;
    }

    const count = wrapper.querySelectorAll(".rb-item:not(.hidden)").length;
    const breakersPresent =
      wrapper.querySelectorAll(".pm-0123-breaker-item").length;
    const expected = Math.floor(count / getBreakerStep(wrapper));

    if (count !== lastCount || breakersPresent !== expected) {
      lastCount = count;
      placeBreakers();
    }
  };

  const schedule = () => {
    if (scheduled) {
      return;
    }
    scheduled = true;
    requestAnimationFrame(check);
  };

  const observer = new MutationObserver(schedule);

  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });

  let resizeTimer;
  let lastWidth = window.innerWidth;
  window.addEventListener("resize", () => {
    if (window.innerWidth === lastWidth) {
      return;
    }
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      lastCount = -1;
      schedule();
    }, 150);
  });

  //Initial run
  check();
};

document.addEventListener("DOMContentLoaded", (event) => {
  elementIsInView(".rb-items-wrapper .rb-item", () => {
    addObserver();
  });
});
